<template>
  <div class="pa-5">
    <v-skeleton-loader
      class="mx-auto"
      v-if="!abouts"
      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
    ></v-skeleton-loader>
    <v-card shaped class="elevation-10" v-else>
      <v-card-title>รายการข้อมูล</v-card-title>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 90%;">เกี่ยวกับ</th>
              <th style="width: 10%;">แก้ไข</th>
            </tr>
          </thead>
          <tbody v-if="abouts.length > 0">
            <tr v-for="item in abouts" :key="item.id">
              <td>{{ item.name }}</td>
              <td>
                <v-btn fab icon color="info" :to="`/about/${item.id}/edit`"><v-icon>mdi-pencil</v-icon></v-btn>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <v-subheader>---ไม่พบข้อมูลในระบบ---</v-subheader>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    abouts: [],
    confirm_delete: false
  }),
  created() {
    this.getAbouts();
  },
  methods: {
    getAbouts() {
      this.$store.dispatch('about/list').then(data => this.abouts = data);
    }
  }
}
</script>